/**
 * The instrument language, extracted from the hero ring.
 *
 * The ring itself stays where it is — a canvas of several thousand animated
 * dots is worth paying for once, on arrival, and a signature that appears on
 * every page stops being one. What travels is the vocabulary: the monospace
 * stamp, the elbow connector, the plotted reading on an arc.
 *
 * The rule these are built to: at most one instrument element per screenful,
 * and it must annotate something real — a score, a date, a step, a service ID.
 * The moment it labels nothing it is wallpaper, and the motif is spent.
 */

export { default as Arc } from './Arc';
export type { ArcProps } from './Arc';
export { default as Connector } from './Connector';
export type { ConnectorProps } from './Connector';
export { default as Stamp } from './Stamp';
export type { StampProps } from './Stamp';
export { arcLength, arcPath, clamp01, dialAngle, ticksAlong, TAU } from './geometry';
